export const RATECALC = [
  {
    label: "Pcs",
    value: "P",
  },
  {
    label: "Weight",
    value: "W",
  },
];
